import { FC, useState } from 'react';
import { Heading, Text } from '@livechat/design-system-react-components';

import { ExpandingMenu } from 'components/expanding-menu/ExpandingMenu';
import { FilteredOrganization } from 'types/organization';

import { OrganizationDetails } from '../organization-details/OrganizationDetails';

import {
  organizationNameContainerStyles,
  yourOrganizationStyles,
  organizationNameStyles,
} from './styles';

type Props = {
  organization: FilteredOrganization;
  textPlatformAsProductEnabled: boolean;
};

export const OrganizationMenu: FC<Props> = ({ organization, textPlatformAsProductEnabled }) => {
  const [isMenuVisibile, setIsMenuVisible] = useState(false);

  const onClickOutside = () => {
    setIsMenuVisible(false);
  };

  const toggleMenu = () => {
    setIsMenuVisible((prev) => !prev);
  };

  const menuTitle = (
    <div css={organizationNameContainerStyles} data-testid="organization-menu">
      {organization.name ? (
        <div>
          <Text size="xs" css={yourOrganizationStyles}>
            Your organization:
          </Text>
          <Heading size="xs" css={organizationNameStyles(isMenuVisibile)}>
            {organization.name}
          </Heading>
        </div>
      ) : (
        <div>
          <Text size="xs" css={yourOrganizationStyles}>
            Organization created on
          </Text>
          <Heading size="xs" css={organizationNameStyles(isMenuVisibile)}>
            {organization.createdAt}
          </Heading>
        </div>
      )}
    </div>
  );

  return (
    <ExpandingMenu
      title={menuTitle}
      isMenuVisible={isMenuVisibile}
      onClickOutside={onClickOutside}
      toggleMenu={toggleMenu}
    >
      <OrganizationDetails
        organization={organization}
        textPlatformAsProductEnabled={textPlatformAsProductEnabled}
      />
    </ExpandingMenu>
  );
};
